// libraries and utilities
import { put, call, takeEvery } from 'redux-saga/effects';
import { toast } from 'helpers/toast';
// Redux
import * as questionnaireActions from './questionnaire.action';
import { apiURL } from '../../config/baseURL';
import API from '../../helpers/api';
import i18n from '../../i18n';

/**
 * Archive (soft-delete) a questionnaire via the questionnaires API. Replaces the direct
 * RTDB writes to /questionnaire/:org/:version and /questionnaireIndex/:org/:key with a
 * single DELETE call so the change dual-writes to Mongo instead of relying on the RTDB
 * sync trigger (ADR-052).
 */
export function* disableQuestionnaire(
	action: ReturnType<typeof questionnaireActions.disableQuestionnaireAsync.request>,
) {
	try {
		const token: string = yield call(API.getFirebaseToken);

		const url = `${apiURL}/questionnaires/${encodeURIComponent(action.payload.qIndexID)}`;
		const res: Response = yield call(API.delete, url, token);

		if (res.status !== 200) {
			toast.error(i18n.t('error.common.fetchAccess'));
			yield put(
				questionnaireActions.disableQuestionnaireAsync.failure({ message: 'Unable to archive questionnaire.' }),
			);
			return;
		}

		yield put(questionnaireActions.disableQuestionnaireAsync.success());
		yield put(
			questionnaireActions.fetchPaginateQuestionnairesAsync.request({ sortFields: 'title', sortDirections: 'asc' }),
		);
	} catch (err) {
		toast.error(i18n.t('error.common.errorUnknown'));
		yield put(
			questionnaireActions.disableQuestionnaireAsync.failure({ message: 'Unable to archive questionnaire.' }),
		);
	}
}

export default function* QuestionnaireSagaDisableQuestionnaire() {
	yield takeEvery(questionnaireActions.disableQuestionnaireAsync.request, disableQuestionnaire);
}
